<!-- <app-navbar-style-one></app-navbar-style-one> -->

<div class="inner-banner inner-bg10">
    <div class="container">
        <div class="inner-title text-center">
            <h3>المنتجات المفضلة</h3>
        </div>
    </div>
</div>
<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
    {{errorMsg}}
</div>
<section class="checkout-area pt-100 pb-70" dir="rtl">
    <div class="container">
      <div class="favorite-container">
        <h3 class="section-title">المنتجات المفضلة</h3>
  
        <div *ngIf="favorites?.length === 0" class="empty-state">
          <i class="far fa-heart"></i>
          <p>لا يوجد منتجات مفضلة حالياً</p>
          <button class="btn-primary" routerLink="/products">تصفح المنتجات</button>
        </div>
  
        <div class="products-grid">
          <div *ngFor="let product of favorites" class="product-card">
            <div class="product-image">
              <img [src]="product.avatar" (error)="handleImageError($event)" alt="{{ product.name }}">
              <div *ngIf="product.offer" class="offer-badge" 
                  [ngClass]="{'discount': product.offer.type === 'discount', 'offer': product.offer.type !== 'discount'}">
                {{product.offer.type === 'discount' ? product.offer.value + '%' : 'عرض'}}
              </div>
              <button class="heart-btn" (click)="toggleFavorite(product.id, product)">
                <i [class]="product.isFavorite ? 'fas fa-heart' : 'far fa-heart'"></i>
              </button>
            </div>
  
            <div class="product-info">
              <h4 class="product-name">{{ product.name }}</h4>
  
              <div *ngIf="product.components?.length" class="product-components">
                <span *ngFor="let comp of product.components" class="component-tag">{{ comp.name }}</span>
              </div>
  
              <!-- <div class="product-rating">
                <div class="stars">
                  <i *ngFor="let star of [1,2,3,4,5]" 
                     [class]="star <= product.rate ? 'fas fa-star' : 'far fa-star'"></i>
                </div>
                <span class="rate-count">({{ product.rate || 0 }})</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  

<!-- <app-footer-style-two></app-footer-style-two> -->